export enum GeoTestTacticType {
  singleTactic = 'SINGLE_TACTIC',
  multiTactic = 'MULTI_TACTIC'
}

export enum GeoTestKpiType {
  singleKpi = 'SINGLE_KPI',
  multiKpi = 'MULTI_KPI'
}

export enum GeoTestResultType {
  positive = 'POSITIVE',
  negative = 'NEGATIVE'
}

export enum GeoTestCalibrationType {
  calibrated = 'CALIBRATED',
  uncalibrated = 'UNCALIBRATED',
  notAvailable = 'NOT_AVAILABLE'
}
